"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.hasCashbackSuperType = void 0;

var _constants = require("../constants");

var hasCashbackSuperType = function hasCashbackSuperType(cashbackType) {
  if (!cashbackType) return false;
  return !_constants.standardCashbackTypes.includes(cashbackType);
};

exports.hasCashbackSuperType = hasCashbackSuperType;